import * as angular from "angular";
import {IController} from "angular";

export class billingAccountsViewCtrl implements IController {

  /* @ngInject */
  constructor() {
  }
}

angular
  .module('bringoz.admin.billing-accounts')
  .component('billingAccounts', {
    bindings: {},
    template: require('./billing-accounts.html').default,
    controller: billingAccountsViewCtrl
  });
